import bowser from 'bowser';

export class SmDeviceDetected {

  private readonly _navUserAgent: string;
  private readonly _smallDevice: boolean;

  constructor() {
    // console.log(bowser);
    this._navUserAgent = navigator.userAgent;
    //get if it is a mobile device or tablet based on user-agent
    if((bowser.tablet || bowser.mobile) && !(bowser.msie && bowser._detect('Trident/7.0'))) {
      this._smallDevice = true;
    }
    else{
      this._smallDevice = false;
    }
  }

  get smallDevice () {
    //return smallDevice property
    return this._smallDevice;
  }

  get deviceOS () {
    //return OS if it is a small device (Only IOS and ANDROID apps supported in dssb)
    if (this._smallDevice){
        return (bowser.ios) ? 'IOS' : ( (bowser.android) ? "ANDROID" : "");
    }
     else{
      return "";
    }

  }

}
